import { Component, OnInit, Input, Optional, ViewChild, ElementRef, NgZone, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { UtilityService } from '../../Shared/services/UtilityService';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { FileUploader, FileDropDirective, FileLikeObject, FileItem } from 'ng2-file-upload';
import { FileDTO } from '../../Shared/Models/FileDTO';
import { ImageUploadOptions } from '../../Shared/Models/ImageUploadOptions';
import { CropperComponent } from 'angular-cropperjs';


@Component({
  selector: 'BBSF-ImageUpload',
  templateUrl: './ImageUpload.component.html',
  styleUrls: ['./ImageUpload.component.scss']
})
export class ImageUploaderComponent implements OnInit {

  static controlContainerstatic = null;

  @ViewChild('fileInput',{static:true,read:null}) fileInput: ElementRef;
  files: File[] = [];
  ImageSource: string = "../../../assets/images/imagenotfound.png"
  isSubmitted: boolean;
  @Input() group: FormGroup;
  @Input() options: ImageUploadOptions;
  @Output() OnChange = new EventEmitter();

  ImageUploadFormControl: AbstractControl;
  ValidationMessage = ""
  uploader: FileUploader;
  hasAnotherDropZoneOver: boolean;
  AcceptedType: string = "";
  AcceptedTypeArray: string[] = [];
  ToolTipTypeArray: string[] = [];
  FileLikeObject: FileLikeObject;
  control: FormControl;
  @ViewChild('angularCropper', {static:true,read:null}) public angularCropper: CropperComponent;
  imgUrl = null;
  config = null;
  imageUrl = ""
  imgwUrl = ""
  EventFile: any;
  mdlSampleIsOpen: boolean = false;
  markAllAsTouched: boolean = false;
  validationRules = [];
  validationRulesasync = [];

  constructor(private zone: NgZone, private ErrorHandler: ErrorMassageValidation, private controlUtility: ControlUtility, @Optional() private controlContainer: ControlContainer, public ImageUplaoderControlHost: FormGroupDirective) {
    ImageUploaderComponent.controlContainerstatic = this.controlContainer;
    this.uploader = new FileUploader({
      disableMultipart: false, // 'DisableMultipart' must be 'true' for formatDataFunction to be called.
    });
    this.hasAnotherDropZoneOver = false;
  }


  ngOnInit() {
    UtilityService.isCreatedBefor = false

    if (this.options.DefaultImageSrc != null && this.options.DefaultImageSrc != "")
      this.ImageSource = this.options.DefaultImageSrc

    if (this.options.AllowImageCropper) {
      this.config = {
        aspectRatio: this.options.ImageCropperWidth / this.options.ImageCropperHeight,
        dragMode: 'move',
        background: true,
        movable: true,
        rotatable: true,
        scalable: true,
        zoomable: true,
        viewMode: 1,
        checkImageOrigin: true,
        modal: true,
        checkCrossOrigin: false,
        width: this.options.ImageCropperWidth,
        height: this.options.ImageCropperHeight,
        cropBoxResizable: false,
        autoCrop: true

      };
    }

    if (this.options.FileUploadAcceptsTypes != null) {
      this.options.FileUploadAcceptsTypes
    }
    if (this.options.Value != null) {

      let element = this.options.Value;
      this.FileLikeObject = new FileLikeObject({
        name: element.FileName,
        size: element.FileSizeInMB * 1000 * 1000,
        type: element.FileType
      })
      this.uploader.addToQueue([this.FileLikeObject as any])

    }

    if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0) {
      for (let index = 0; index < this.options.FileUploadAcceptsTypes.length; index++) {
        const Type = this.options.FileUploadAcceptsTypes[index];
        this.AcceptedType = this.AcceptedType + Type
      }
      this.AcceptedTypeArray = this.AcceptedType.split(",")
      for (let index = 0; index < this.AcceptedTypeArray.length; index++) {
        const element = this.AcceptedTypeArray[index];
        const TypeToolTipe = element.split('/')[1];
        this.ToolTipTypeArray.push(TypeToolTipe);
      }
      this.ValidationMessage = this.ValidationMessage + ` Allowed extenstions (${this.ToolTipTypeArray}) `

    }
    if (this.options.FileMaxSizeInMB > 0) {
      this.ValidationMessage = this.ValidationMessage + ` <br />Max File Size ${this.options.FileMaxSizeInMB} MB`
    }
    if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0) {
    }
    this.group.addControl(this.options.Name, new FormControl(''));
    this.ImageUploadFormControl = this.group.controls[this.options.Name]; //  new FormControl('',validationRules);

    if (this.options.LabelKey != null && this.options.LabelKey != "")
      this.options.LabelValue = UtilityService.getResourceValue(this.options.LabelKey);

    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.validationRules.push(Validation.functionBody);
      }

    }



    if (this.options.IsRequired) {
      this.validationRules.push(Validators.required);
    }

    this.ImageUploadFormControl.setValidators(this.validationRules);
    this.ImageUploadFormControl.setAsyncValidators(this.validationRulesasync);
    if (this.options.IsDisabled) {
      this.ImageUploadFormControl.disable();
    }
    this.ImageUplaoderControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

  }

  ngAfterViewInit(): void {
    if (this.options.AttributeList != null) {
      var element = document.getElementById(this.options.Name);
      for (let index = 0; index < this.options.AttributeList.length; index++) {
        element.setAttribute(this.options.AttributeList[index].Key, this.options.AttributeList[index].value);
      }

    }

  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }

  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }

    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }


  onFileChange(event) {
    if (event.rejectedFiles.length > 0) {
      const file = event.rejectedFiles[0];
      const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
      const fileType = file.type;
      if (file.size > maxFileSize) {
        const formControl = this.ImageUploadFormControl;
        formControl.setErrors({ FileMaxSizeInMB: this.options.FileMaxSizeInMB + 'M' });
        formControl.markAsTouched();
        this.uploader.queue = [];
        return;
      }
      if (this.options.FileUploadAcceptsTypes != null && this.options.FileUploadAcceptsTypes.length > 0 && !(this.AcceptedTypeArray.includes(fileType.toUpperCase()) || this.AcceptedTypeArray.includes(fileType.toLowerCase()))) {
        const formControl = this.ImageUploadFormControl;
        formControl.setErrors({ ToolTipTypeError: this.ToolTipTypeArray });
        formControl.markAsTouched();
        this.uploader.queue = [];
        return;
      }
    }
    let FilesArray = [];
    for (let index = 0; index < event.addedFiles.length; index++) {
      const file = event.addedFiles[0];
      this.EventFile = file
      const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
      if (file) {
        const maxFileSize = this.options.FileMaxSizeInMB * 1000 * 1000;
        const fileType = file.type;
        if (file.size > maxFileSize) {
          const formControl = this.ImageUploadFormControl;
          formControl.setErrors({ FileMaxSizeInMB: this.options.FileMaxSizeInMB + 'M' });
          formControl.markAsTouched();
          this.uploader.queue = [];
          return;
        }
        let reader = new FileReader();
        let FileObject = file;
        reader.readAsDataURL(FileObject);
        reader.onload = () => {
          if (this.options.AllowImageCropper) {
            this.imageUrl = reader.result.toString();
            this.openModal(true)

          }
          else {
            let FileObject = new FileDTO();
            FileObject.FileName = file.name;
            FileObject.FileType = file.type;
            FileObject.FileBase64 = reader.result.toString().split(',')[1];
            FileObject.FileSizeInMB = ((file.size / 1000) / 1000);
            FilesArray.push(FileObject);
            this.group.get(this.options.Name).setValue(FileObject);
            this.files = [];
            this.files.push(...event.addedFiles);
          }
          this.OnChange.emit(this.ImageUploadFormControl.value)
        };
      }
    }
  }

  removeFromControlValue(event) {
    let ItemList = this.group.get(this.options.Name).value;
    this.files = [];
    ItemList = null
    if ((this.files.length == 0) && this.options.IsRequired) {
      this.ImageUploadFormControl.markAsTouched();
      this.ImageUploadFormControl.setErrors(Validators.required)
      this.ImageUploadFormControl.invalid
    }
    this.group.get(this.options.Name).setValue(ItemList);
    this.OnChange.emit(this.group.get(this.options.Name).value)

  }

  cropImage() {
    let ImageCropperObject = this.angularCropper.cropper.getCroppedCanvas(
      {
        width: this.options.ImageCropperWidth,
        height: this.options.ImageCropperHeight,
        imageSmoothingEnabled: false,
        imageSmoothingQuality: 'high',
      }
    );
    ImageCropperObject.toBlob((blob) => {
      this.zone.run(() => {
        this.getBlobFile(blob);
      });

    });
  }

  getBlobFile(blob) {
    let FilesArray = [];
    let BlobFile;
    let reader = new FileReader();
    BlobFile = blob;
    reader.readAsDataURL(BlobFile);
    reader.onload = () => {
      let FileObject = new FileDTO();
      BlobFile.name = this.EventFile.name
      FileObject.FileName = this.EventFile.name;
      FileObject.FileType = this.EventFile.type;
      FileObject.FileBase64 = reader.result.toString().split(',')[1];
      FileObject.FileSizeInMB = ((BlobFile.size / 1000) / 1000);
      FilesArray.push(FileObject);
      this.group.get(this.options.Name).setValue(FileObject);
      this.files = [];
      this.files.push(BlobFile);
      this.openModal(false);


    }
  }


  rotateImage(degree: number) {
    this.angularCropper.cropper.rotate(degree)
  }
  moveImage(offsetX: number, offsetY: number) {
    this.angularCropper.cropper.move(offsetX, offsetY)
  }
  zoomImage(ratio: number) {
    this.angularCropper.cropper.zoom(ratio)
  }


  openModal(open: boolean): void {
    this.mdlSampleIsOpen = open;
  }

  //External Method

  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.ImageUploadFormControl, this.validationRules, this.options)
  }
  //External Method

  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.ImageUploadFormControl, this.validationRules, this.options)
  }

  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.ImageUploadFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.ImageUploadFormControl, this.validationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.ImageUploadFormControl)
  }

}


